import type {
  SelectOption,
  SelectProps,
} from '@movingimage-evp/mi-ui-component-library/types/components/select/select';

import { LanguageIcon, Select } from '@movingimage-evp/mi-ui-component-library';
import { useTranslation } from 'react-i18next';

import { getLanguageKey } from '../../../utils/languages';
import { useSelectedLanguage } from '../../providers/selected-language-provider';

import styles from './viewer-language-switch.module.css';

export function ViewerLanguageSwitch(props: SelectProps) {
  const { t } = useTranslation();
  const { availableLanguages, selectedLanguage, selectLanguage } = useSelectedLanguage();

  if (!selectedLanguage || !availableLanguages || (availableLanguages && availableLanguages?.length < 2)) return null;

  const options = availableLanguages.map((language) => {
    const code = language?.code;
    const name = language.__typename === 'CustomLanguage' ? language?.name : undefined;

    return {
      key: code,
      label: name || t(`common.languageSwitch.options.${getLanguageKey(code)}.optionLabel`),
      displayLabel: name || t(`common.languageSwitch.options.${getLanguageKey(code)}.selectedLabel`),
    };
  });

  const value = options.find((option) => option.key === selectedLanguage?.code);

  return (
    <Select
      data-testid="language-switch"
      className={styles.wrapper}
      aria-label={t('common.languageSwitch.ariaLabel')}
      icon={<LanguageIcon />}
      ariaLabel={t('common.languageSwitch.ariaLabel')}
      optionsIdProperty="key"
      value={value}
      options={options}
      onChange={(option: SelectOption) => selectLanguage(option.key)}
      getDisplayLabel={(option: SelectOption) => option.displayLabel}
      {...props}
    />
  );
}
